import styled, { css } from 'styled-components'

export const TagContainer = styled.div`
  ${({ theme: { color, typography, spacing } }) => css`
    word-break: break-all;
    overflow-y: scroll;
    height: 280px;
    a {
      display: inline;
      height: 30px;
      color: #2f78d8;
      text-align: center;
      font-size: ${typography.textSmall};
      line-height: 28px;
      border-radius: 4px;
      word-break: break-word;
      padding: 5px 0px;
      :hover {
        color: #2f78d8;
      }
    }
    span {
      color: #2f78d8;
      padding: 0 10px;
    }
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      position: fixed;
      display: block;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 2px;
      position: fixed;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.38);
      border-radius: 4px;
      position: fixed;
    }
  `}
`
